module.exports = __webpack_public_path__ + "img/review-csp.25bf6b81.png";